import { type TemplateOnlyComponent } from '@ember/component/template-only';

import type { EditingMode } from './utils.ts';

const EditorCard: TemplateOnlyComponent<{
  Args: {
    questionType: string | number;
    editorType: EditingMode;
  };
  Blocks: {
    default: [];
  };
}> = <template>
  <div
    class="card rounded-top-0 border-top-0 bg-primary-subtle ll-question-{{@editorType}}-editor-{{@questionType}}
      w-100"
  >
    {{yield}}
  </div>
</template>;

export default EditorCard;
